module.exports = __webpack_public_path__ + "de0a05453a739f1999e5019c3a1efb5a.jpg";